import playstore from "../../asset/images/playstore.png";

const GetStarted = () => {
  return (
    <section style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      flexDirection: 'column', 
      textAlign: 'center', 
      padding: '4rem 1.5rem', 
      position: 'relative', 
      overflow: 'hidden',
      backgroundColor: '#f8f9fa'
    }}>
      
      {/* Abstract circles for decoration */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '60px',
        height: '60px',
        backgroundColor: 'rgba(230, 237, 245, 0.8)',
        borderRadius: '50%'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '20%',
        width: '80px',
        height: '80px',
        backgroundColor: 'rgba(230, 237, 245, 0.6)',
        borderRadius: '50%'
      }}></div>
      <div style={{
        position: 'absolute',
        top: '25%',
        right: '5%',
        width: '70px',
        height: '70px',
        backgroundColor: 'rgba(230, 237, 245, 0.7)',
        borderRadius: '50%'
      }}></div>
      
      {/* Section Content */}
      <h2 style={{ 
        fontSize: 'clamp(1.75rem, 5vw, 2.5rem)', 
        fontWeight: 'bold', 
        color: '#212529', 
        marginBottom: '1rem'
      }}>
        Ready to Get Started?
      </h2>
      <p style={{ 
        fontSize: 'clamp(0.875rem, 2vw, 1rem)', 
        color: '#6c757d', 
        maxWidth: '600px', 
        marginBottom: '2rem'
      }}>
        Join millions of users who trust our app for their mobile recharge needs. Download now and experience the difference.
      </p>

      {/* Download Buttons */}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        '@media (min-width: 640px)': { 
          flexDirection: 'row', 
          justifyContent: 'center', 
          gap: '1rem' 
        } 
      }}>
        
        <a href="#" style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#212529',
          color: '#fff',
          padding: '0.75rem 1.5rem',
          borderRadius: '0.5rem',
          textDecoration: 'none',
          transition: 'background-color 0.3s ease'
        }}>
          <img src={playstore} alt="Google Play logo" style={{ marginRight: '0.5rem', width: '24px', height: '24px' }} />
          Play Store
        </a>
      </div>

      {/* Ratings and Downloads */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '2rem',
        gap: '1.5rem',
        '@media (min-width: 768px)': { 
          flexDirection: 'row',
          gap: '2.5rem'
        }
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem',
        }}>
          <span style={{ color: '#ffc107', fontSize: '1.25rem' }}>&#9733;&#9733;&#9733;&#9733;&#9733;</span>
          {/* <span style={{ color: '#6c757d', fontSize: '0.875rem' }}>4.8 out of 5</span> */}
        </div>
        {/* <span style={{ color: '#ced4da' }}>|</span> */}
        {/* <span style={{ color: '#6c757d', fontSize: '0.875rem' }}>Over 25,000 reviews</span> */}
        {/* <span style={{ color: '#ced4da' }}>|</span> */}
        {/* <span style={{ color: '#6c757d', fontSize: '0.875rem' }}>500K+ downloads</span> */}
      </div>
    </section>
  );
};

export default GetStarted;
